export default {
  install(Vue) {
    const breakpoints = Vue.observable({
      isMobile: false,
      isTablet: false,
      isDesktop: false,
      size: null,
    })
    
    const updateBreakpoint = () => {
      const windowSize = window.innerWidth
      breakpoints.size = windowSize
      breakpoints.isMobile = windowSize < 768    
      breakpoints.isTablet = windowSize < 1024 && !breakpoints.isMobile
      breakpoints.isDesktop = windowSize > 1024
      Vue.prototype.$breakpoint = breakpoints
    }
    
    updateBreakpoint()
    
    window.addEventListener('resize', updateBreakpoint)
  }
}